<template>
    <div id="message-panel">
        <v-snackbar
                v-model="display"
                bottom
                :style="{ 'margin-left': marginLeft + 'px'}"
                :color="color"
                :timeout="timeout">
            <span v-html="message"></span>
            <v-btn dark
                   text
                   @click="display = false">
                Fermer
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
    import {mapState} from "vuex"

    export default {
        name: "MessagePanel",
        data() {
            return {
                message: null,
                display: false,
                color: '',
                timeout: 5000
            }
        },
        computed: {
            ...mapState('global', ['leftMenuClosed', 'maintenance']),
            marginLeft() {
                return this.leftMenuClosed !== null ? (this.leftMenuClosed ? 90 : 256) : 0
            }
        },
        created() {
            this.$global.$on('unhandled-error', () => {
                if(this.maintenance) {
                    this.message = 'Nous sommes actuellement en maintenance. Le service est temporairement indisponible. Veuillez nous excuser pour ce désagrément.'
                } else {
                    this.message = 'Une erreur interne est survenue. Merci de contacter le support technique à l\'adresse support@dahub.io'
                }

                this.color = 'error'
                this.display = true
                this.timeout = 0

                this.$global.loading = false
            })

            this.$global.$on('handled-error', (response) => {
                this.message = response.body.message
                this.color = 'error'
                this.display = true
                this.timeout = 8000
            })

            this.$global.$on('success-request', (response) => {
                if(response.body.message !== undefined && response.body.message !== null) {
                    this.message = response.body.message
                    this.color = response.body.color !== undefined ? response.body.color : 'success'
                    this.display = true
                    this.timeout = 15000
                }
            })

            this.$global.$on('hide-msg', () => {
                this.display = false
                this.message = null
            })
        },
        beforeDestroy() {
            this.$global.$off('unhandled-error')
            this.$global.$off('handled-error')
            this.$global.$off('success-request')
            this.$global.$off('hide-msg')
        }
    }
</script>